import PropTypes from 'prop-types'
import React from 'react'
import styles from './_spinner.css'
import classnames from 'classnames'

const propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.string,
  style: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  className: PropTypes.string,
}

export function Spinner ({ height, width, color = '#666', style, className }) {
  return (
    <div className={classnames(styles.container, className)} style={{ height, width, ...style }}>
      {Array(12).fill(0).map((_, i) => (
        <div
          key={i}
          className={styles[`blade_${i}`]}
          style={{ backgroundColor: color }}
        />
      ))}
    </div>
  )
}

Spinner.propTypes = propTypes

export default Spinner
